// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvpxbi{padding-left:var(--ds-space-200,1pc)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._bfhkm7j4{background-color:var(--ds-background-neutral,#091e420f)}\n._ca0qpxbi{padding-top:var(--ds-space-200,1pc)}\n._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}\n._u5f3pxbi{padding-right:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
